/**
 * This module provides functions to interact with the reports-related API endpoints.
 * It uses axios for HTTP requests to communicate with the backend server.
 */
import { apiGet, apiPost, validateRequiredParams } from '@/services/BaseApiService';

const baseUrl = '/annualreports/';

/**
 * Retrieves outstanding or complete annual reports.
 * 
 * @param {integer} userId - The unique identifier of the contact to retrieve reports for.
 * @param {boolean} isCompleted - whether the reports are completed or not.
 * @returns {Promise<Object>} The organization's details if the retrieval is successful.
 * @throws Will throw an error if the `userId` parameter is missing or if the retrieval fails.
 */
export const getAnnualReports = async (isCompleted) => {
  validateRequiredParams({ isCompleted });
  return apiGet(`${baseUrl}getannualreports`, { isCompleted });
};

export const createHpAnnualReport = async (organizationId, periodId, contactId, roleId) => {
  validateRequiredParams({ organizationId, periodId, contactId, roleId });
  return apiPost(`${baseUrl}createhpannualreport`, { organizationId, periodId, contactId, roleId });
};

export const getSectionDefinitions = async(reportType, attributeSectionId) => {
  validateRequiredParams({ reportType });
  return apiGet(`${baseUrl}getsectiondefinitions`, { reportType, attributeSectionId });
};
